import styled from 'styled-components';

export const ModelInputStyle = styled.div`
  .custom-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(10, 14, 20, 0.75);
    backdrop-filter: blur(6px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.2s ease-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  .custom-modal {
    width: 440px;
    max-width: 94vw;
    background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 
      0 24px 60px rgba(0, 0, 0, 0.25),
      0 0 0 1px rgba(255, 255, 255, 0.6) inset,
      0 1px 3px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    animation: slideUp 0.25s ease-out;
  }

  .custom-modal-header {
    padding: 24px 28px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .modal-title {
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.01em;
    line-height: 1.3;
  }

  .close-btn {
    background: transparent;
    border: none;
    font-size: 24px;
    line-height: 1;
    color: #94a3b8;
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.15s ease;
    padding: 0;

    &:hover {
      background: #f1f5f9;
      color: #475569;
    }
  }

  .list {
    max-height: 160px;
    overflow-y: auto;
    padding: 0 28px;
    margin-bottom: 8px;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #cbd5e1;
      border-radius: 4px;
    }
  }

  .notice {
    color: #dc2626;
    font-size: 13px;
    line-height: 1.6;
    word-break: break-all;
    margin-bottom: 6px;
    text-align: left;
    padding: 8px 12px;
    background: #fef2f2;
    border-radius: 8px;
    border-left: 3px solid #dc2626;
  }

  .custom-modal-body {
    padding: 10px 28px;
    display: flex;
    align-items:center;
    // flex-direction: column;
    gap: 10px;
  }

  .input-label {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    letter-spacing: 0.01em;
  }


  .fee-info {
    padding: 12px 28px 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 6px;
    font-size: 13px;
    color: #64748b;
  }

  .fee-label {
    font-weight: 600;
    color: #475569;
    margin-right: 4px;
  }

  .fee-original {
    text-decoration: line-through;
    color: #94a3b8;
  }

  .fee-member {
    color: #1fc7d4;
    font-weight: 700;
    font-size: 14px;
  }

  .fee-unit {
    color: #94a3b8;
    font-size: 12px;
  }

  .custom-modal-footer {
    padding: 16px 28px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  .btn {
    padding: 11px 28px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: all 0.2s ease;
    letter-spacing: 0.01em;
    line-height: 1;
  }

  .btn-cancel {
    background: #f1f5f9;
    color: #475569;

    &:hover {
      background: #e2e8f0;
      color: #334155;
    }

    &:active {
      transform: scale(0.97);
    }
  }

  .btn-ok {
    background: linear-gradient(135deg, #1fc7d4 0%, #0ea5b5 100%);
    color: #ffffff;
    box-shadow: 0 4px 14px rgba(31, 199, 212, 0.35);

    &:hover {
      box-shadow: 0 6px 20px rgba(31, 199, 212, 0.45);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0) scale(0.98);
      box-shadow: 0 2px 8px rgba(31, 199, 212, 0.3);
    }
  }

  .members {
    font-size: 20px !important;
  }
`;